import { COMPANY } from "@/data/site";

export default function Footer() {
  return (
    <footer className="bg-[#0f172a] text-slate-400 py-12 border-t border-slate-800 text-xs">
      <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-6">
        <div className="flex items-center gap-3">
          <img src="/ae-logo.png" alt="Anas Enterprises AE logo" className="h-9 w-auto object-contain bg-white rounded p-0.5" />
          <span className="text-white font-bold tracking-wider">ANAS ENTERPRISES CIVIL INTERIOR CONTRACTOR</span>
        </div>
        <p className="text-slate-500 text-center md:text-right">© 2025 Anas Enterprises. GSTIN: {COMPANY.gst}. Malad (East), Mumbai 400097.</p>
      </div>
    </footer>
  );
}
